export default "__VITE_ASSET__4976f85e__"